import React, { PureComponent } from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer
} from "recharts";

import Teams from "../../api/Teams";
import Auth from "../../routes/Auth";

const getCurrentToken = () => {
  return Auth.getToken();
};

const getCurrentCourseId = () => {
  return Auth.getCourseId();
};

const getCurrentUserId = () => {
  return Auth.getUserId();
};

function formatNumber(val, precision) {
  return val.toFixed(precision);
}

function CustomLabel({
  x,
  y,
  width,
  height,
  value,
  prefix,
  suffix,
  precision,
  layout = "horizontal",
  xOffset = 30,
  format
}) {
  const xxOffset =
    layout === "horizontal"
      ? x + width / 2
      : value < 0
        ? x + width - xOffset
        : x + width + xOffset;
  const yOffset =
    layout === "vertical" ? y + height / 2 : value < 0 ? y + 10 : y - 10;
  const className = value < 0 ? "red" : null;
  const val = `${prefix}${format ? format(value, precision) : formatNumber(value, precision)
    }${suffix}`;

  return (
    <g>
      <text
        x={xxOffset}
        y={yOffset}
        className={className}
        textAnchor="middle"
        dominantBaseline="middle"
      >
        {val}
      </text>
    </g>
  );
}

function TooltipContent({ active, payload, label, prefix, suffix, format }) {
  const tooltipStyle = {
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  };

  if (active) {
    let value = "";
    let style = {};

    if (payload && payload.length > 0) {
      value = format ? format(payload[0].value) : payload[0].value.toFixed(2);
      if (payload[0].value < 0) {
        style = {
          color: "red"
        };
      }
    }

    return (
      <div className="recharts-default-tooltip" style={tooltipStyle}>
        {label}:{" "}
        <span style={style}>
          {prefix}
          {value}
          {suffix}
        </span>
      </div>
    );
  }

  return null;
}

class CustomXAxisLabel extends PureComponent {
  render() {
    const { x, y, payload, data, instructorData } = this.props;

    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={10} textAnchor="middle" fill="#666">
          {data[payload.index].name}
        </text>
        <a
          href={`/analysis/team-reports/grades-ranks/${instructorData.type
            }?team_id=${data[payload.index].id}&round_number=${instructorData.roundNumber
            }&game_id=${instructorData.currentGame
            }&_token=${getCurrentToken()}&_userid=${getCurrentUserId()}&_courseid=${getCurrentCourseId()}&_target=blank`}
          target="_blank"
          rel="noreferrer"
        >
          <text
            x={0}
            y={0}
            dy={25}
            textAnchor="middle"
            fill="#666"
          >
            View
          </text>
        </a>
      </g>
    );
  }
}

function HorizontalBar({
  prefix = "",
  suffix = "",
  precision = 2,
  data = [],
  barSize = 18,
  format = null,
  customColors = null,
  showCategoryLabels = false,
  instructorData = null,
  teams = null,
  yaxisFormatter = null,
}) {
  const colors = customColors ? customColors : Teams.competitiveColors(teams);

  return (
    <ResponsiveContainer height={200}>
      <BarChart data={data} barSize={barSize}>
        {!instructorData && (
          <XAxis dataKey="name" tickLine={false} tick={showCategoryLabels} />
        )}
        {instructorData && (
          <XAxis
            dataKey="name"
            tickLine={false}
            tick={
              <CustomXAxisLabel data={data} instructorData={instructorData} />
            }
          />
        )}
        <YAxis
          hide={false}
          // When every team is 0, dataMax * 1.2 = 0 and recharts renders
          // decimal filler ticks (0.25, 0.5, 0.75...). Fall back to a
          // domain of [0, 1] so the axis stays clean and bars sit at
          // baseline instead of drawing 5px slivers over garbage ticks.
          domain={[dataMin => 0, dataMax => dataMax > 0 ? dataMax * 1.2 : 1]}
          interval="preserveStart"
          tickFormatter={(value) => yaxisFormatter ? yaxisFormatter(value) : value}
        />
        <Tooltip
          content={
            <TooltipContent prefix={prefix} suffix={suffix} format={format} />
          }
        />
        <Bar
          dataKey="value"
          minPointSize={5}
          isAnimationActive={!showCategoryLabels}
          label={
            <CustomLabel
              prefix={prefix}
              suffix={suffix}
              precision={precision}
              format={format}
              instructorData={instructorData}
            />
          }
        >
          {colors.map((color, i) => (
            <Cell key={i} fill={color} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}

export default HorizontalBar;



// WEBPACK FOOTER //
// ./src/components/analysis/horizontal-bar.js